import React, { useEffect, useState } from "react";
import { getServices } from "../api/client";
import { Link } from "react-router-dom";

const Services = ({ settings, lang }) => {
    const [services, setServices] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getServices();
                setServices(response.data.services || []);
                setQuestions(response.data.questions || []);
            } catch (error) {
                console.error("Failed to fetch services:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const getText = (en, ar) => (lang === "en" ? en : ar);
    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_services", "إينوبريدج - خدماتنا");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_services", "إينوبريدج - خدماتنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_services", "إينوبريدج - خدماتنا"));
        }
    }, [lang, settings]);


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            {/* Page Header */}
            <header className="py-5 header1 header">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("services_title", "Our Services")}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("services_desc", "We offer a wide range of services...")}
                    </p>
                </div>
            </header>

            {/* Services Grid */}
            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row gy-4 justify-content-center" id="services-grid">
                        {loading ? (
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            services.length > 0 ? (
                                services.map((r, index) => (
                                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" key={index}>
                                        <div className="card-custom h-100 d-flex flex-column bg-body shadowP">
                                            <div className="mb-4 text-primary">
                                                <i className={`${r.icon} fs-1`}></i>
                                            </div>
                                            <h4 className="fw-bold mb-3">{lang === 'en' ? r.title_en : r.title_ar}</h4>
                                            <p className="mb-4 flex-grow-1">{lang === 'en' ? r.overview_en : r.overview_ar}</p>
                                            <Link to={`/service/${r.slug_en}`} className="fw-bold text-primary mt-auto">
                                                {getText("Read More", "اقرأ المزيد")} <i className="ri-arrow-right-line"></i>
                                            </Link>
                                        </div>
                                    </div>
                                ))
                            ) : (

                                <div className="col-12" data-aos="fade-up" data-aos-delay="100">
                                    <div className="card-custom h-100 py-5 overflow-hidden group text-center bg-body">
                                        <p className="m-0">{getText("There is no services at the moment.", "لا توجد خدمات فى الوقت الحالى")}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container py-4">

                    {/* Title */}
                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {getStatic("faq_title", "Frequently Asked Questions")}
                        </h2>
                        <p className="text-muted fs-5">
                            {getStatic("faq_desc", "Find answers to common questions about our services")}
                        </p>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                {questions.length > 0 ? (
                                    questions.map((q, index) => (
                                        <div className="mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                            <div className="bg-card shadowP" style={{ borderRadius: 12, overflow: "hidden" }}>

                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button text-normal fw-bold collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#faq${index}`}
                                                        aria-expanded="false"
                                                        aria-controls={`faq${index}`}
                                                        style={{ background: "transparent", border: "none", padding: "1.5rem" }}
                                                    >
                                                        {lang === 'en' ? q.question_en : q.question_ar}
                                                    </button>
                                                </h2>

                                                <div
                                                    id={`faq${index}`}
                                                    className="accordion-collapse collapse"
                                                    data-bs-parent="#faqAccordion"
                                                >
                                                    <div className="accordion-body py-3" style={{ padding: "0 1.5rem 1.5rem" }}>
                                                        <p className="mb-0 text-muted">
                                                            {lang === 'en' ? q.answer_en : q.answer_ar}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-5">
                                        <p className="text-muted">{getText("No questions available at the moment.", "لا توجد أسئلة متاحة في الوقت الحالي.")}</p>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 position-relative overflow-hidden bg-card">
                <div className="container py-5 position-relative">
                    <div className="row align-items-center g-4">

                        {/* TEXT SIDE */}
                        <div className="col-lg-7" data-aos="fade-up">

                            <h2 className="fw-bold display-5 mb-4">
                                {getStatic("cta_title", "Ready to Transform Your Business?")}
                            </h2>

                            <p className="lead mb-4">
                                {getStatic(
                                    "cta_description",
                                    "Get a tailored quote designed for your business needs."
                                )}
                            </p>

                            <ul className="list-unstyled mb-4">
                                {[1, 2, 3, 4].map((i) => (
                                    <li key={i} className="mb-2 d-flex align-items-center">
                                        <i className="ri-check-line text-primary fs-5 me-2"></i>
                                        {getStatic(`cta_point${i}`, "Point")}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* FORM SIDE */}
                        <div className="col-lg-5" data-aos="fade-up" data-aos-delay="200">
                            <div className="bg-body p-5 shadowP" style={{ borderRadius: 16 }}>
                                <h4 className="fw-bold mb-4 text-center">
                                    {getStatic("cta_form_title", "Request a Quote")}
                                </h4>

                                <form>
                                    <div className="mb-3">
                                        <input type="text" className="form-control bg-card" placeholder="Full Name" required />
                                    </div>

                                    <div className="mb-3">
                                        <input type="email" className="form-control bg-card" placeholder="Email" required />
                                    </div>

                                    <div className="mb-3">
                                        <input type="tel" className="form-control bg-card" placeholder="Phone" required />
                                    </div>

                                    <div className="mb-3">
                                        <select className="form-control bg-card" required>
                                            <option value="" disabled selected>
                                                {getStatic("cta_select_service", "Select Service")}
                                            </option>
                                            <option value="consulting">Strategic Consulting</option>
                                            <option value="digital">Digital Transformation</option>
                                            <option value="tech">Technology Implementation</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>

                                    <div className="mb-4">
                                        <textarea className="form-control bg-card" rows="4" placeholder="Project Details" required></textarea>
                                    </div>

                                    <button className="btn btn-primary-custom w-100 py-3 fw-bold">
                                        {getStatic("cta_btn", "Get Your Quote")}
                                        <i className="ri-arrow-right-line ms-2"></i>
                                    </button>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>
    );
};

export default Services;
